import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "616.432",
  x2: "100",
  y2: "755.718",
  gradientTransform: "translate(0 -566)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M88.4 144.2v-33.1c-32.2-5-56.1-33.1-56.1-66.2 0-12.4 3.3-24 9.9-33.9l33 33.1L100 17.6l24.8 26.5 33-33.9c5.8 9.9 9.9 21.5 9.9 33.9 0 33.1-23.9 61.3-56.1 66.2v33.1c13.2-22.4 44.6-42.2 78.4-30.6 0 0-29.7 77-90 77-59.4 0-90-77-90-77 34.7-10.8 65.2 9 78.4 31.4z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}